import { useParams } from 'react-router';
import type { Network } from 'types/shared';

const useCurrentNetwork = (): Network => {
  const { network } = useParams<{ network: Network }>();

  if (!network) {
    const retainedNetwork = localStorage.getItem('_network') ?? 'facebook';
    return retainedNetwork as Network;
  }

  return network;
};

export default useCurrentNetwork;
